// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__8B4nB","default":"Button_default__nKr4u","solid":"Button_solid__7no_M","accent":"Button_accent__JByjL","lg":"Button_lg__hef9j","sm":"Button_sm__VDD1a"};